import { createAction } from "redux-act";

export const selectedLanguage = createAction<any>("Fetch language");
